var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _vm._v(
          "\n\t\t" +
            _vm._s(_vm.t("twofactor_totp", "Your new TOTP secret is:")) +
            " " +
            _vm._s(_vm.secret) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.t(
                "twofactor_totp",
                "For quick setup, scan this QR code with your TOTP app:"
              )
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("QR", { attrs: { value: _vm.qrUrl, options: { width: 150 } } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.t(
                "twofactor_totp",
                "After you configured your app, enter a test code below to ensure everything works correctly:"
              )
            ) +
            "\n\t"
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.confirmationCode,
            expression: "confirmationCode"
          }
        ],
        attrs: {
          id: "totp-confirmation",
          type: "tel",
          minlength: "6",
          maxlength: "10",
          autocomplete: "off",
          autocapitalize: "off",
          disabled: _vm.loading,
          placeholder: _vm.t("twofactor_totp", "Authentication code")
        },
        domProps: { value: _vm.confirmationCode },
        on: {
          keydown: _vm.onConfirmKeyDown,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.confirmationCode = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          id: "totp-confirmation-submit",
          type: "button",
          disabled: _vm.loading,
          value: _vm.t("twofactor_totp", "Verify")
        },
        on: { click: _vm.confirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }